import { __ } from "@wordpress/i18n";
import apiFetch from "@wordpress/api-fetch";
import { useSelector, useDispatch } from "react-redux";

const BulkExtensionController = () => {
	const dispatch = useDispatch();

	const blocksStatuses = useSelector((state) => state.blocksStatuses);

	const handleBulkTrigger = (action) => {
		const value = { ...blocksStatuses };

		for (const block in blocksStatuses) {
			value[block] = action === "activate" ? block : "";
		}

		dispatch({ type: "UPDATE_BLOCK_STATUSES", payload: value });

		const formData = new window.FormData();
		formData.append("action", `astra_addon_bulk_${action}_modules`);
		formData.append("security", astra_addon_admin.update_nonce);

		apiFetch({
			url: astra_admin.ajax_url,
			method: "POST",
			body: formData,
		})
			.then((data) => {
				if (data.success) {
					dispatch({
						type: "UPDATE_SETTINGS_SAVED_NOTIFICATION",
						payload:
							action === "activate"
								? __("Successfully Activated!", "astra")
								: __("Successfully Deactivated!", "astra"),
					});
					refreshCache();
				}
			})
			.catch((error) => {
				console.error(`Error during ${action}:`, error);
			});
	};

	const refreshCache = () => {
		const reFormData = new window.FormData();
		reFormData.append("action", "astra_refresh_assets_files");
		reFormData.append("security", astra_addon_admin.update_nonce);
	
		apiFetch({
			url: astra_admin.ajax_url,
			method: "POST",
			body: reFormData,
		})
			.then(() => {
				dispatch({
					type: "UPDATE_SETTINGS_SAVED_NOTIFICATION",
					payload: __("Cache Cleared!", "astra"),
				});
				location.reload();
			})
			.catch((error) => {
				console.error("Error during cache refresh:", error);
				// Handle the error, possibly showing a notification to the user.
			});
	};

	return (
		<span className="z-0 flex shadow-sm rounded-[0.2rem] sm:justify-center w-fit sm:w-auto">
			<button
				type="button"
				className="focus:bg-indigo-50 focus:text-slate-500 focus-visible:text-astra hover:bg-indigo-50 hover:text-astra -ml-px relative inline-flex items-center px-4 py-2 border border-slate-200 bg-white text-sm font-medium text-slate-500 focus:z-10 focus:outline-none rounded-l-md transition"
				onClick={() => handleBulkTrigger("activate")}
			>
				{__("Activate all", "astra")}
			</button>
			<button
				type="button"
				className="focus:bg-indigo-50 focus:text-slate-500 focus-visible:text-astra hover:bg-indigo-50 hover:text-astra -ml-px relative inline-flex items-center px-4 py-2 border border-slate-200 bg-white text-sm font-medium text-slate-500 focus:z-10 focus:outline-none rounded-r-md transition"
				onClick={() => handleBulkTrigger("deactivate")}
			>
				{__("Deactivate all", "astra")}
			</button>
		</span>
	);
};

export default BulkExtensionController;
